module.exports = __webpack_public_path__ + "static/media/pricing.1a890bf5.svg";